import MainLayout from "@/components/layout/applicant/MainLayout.vue";
// import Pagination from "laravel-vue-pagination";
import axios from "axios";
import { mapGetters } from "vuex";
import { ConvertNumService } from "@/assets/js/convertNumberService.js";
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
const convertNumberService = new ConvertNumService();

export default {
    name: "jobRequest",
    components: {
        MainLayout,
        // Pagination,
        AdvancedLaravelVuePaginate
    },

    data() {
        return {
            jobRequestList: {},
            isLoading: true,
            keyword: "",
            page_status: false,
            jobrequest_count: ""
        };
    },

    methods: {
        getJobRequest(page = 1) {
            this.isLoading = true;
            axios.get("/applicant/job_request/list?page=" + page)
            .then((response) => {
                this.jobRequestList = response.data;
                this.jobrequest_count = convertNumberService.convertEng2Mm(this.jobRequestList.total.toString())
            })
            .catch(error => {
                console.log("Get Job Request API Error", error);
            })
            .finally(() => {
                this.isLoading = false;
            });
        },

        searchJobRequest(page = 1) {
            this.isLoading = true;
            var request = {
                params: {
                    keyword: this.keyword
                }
            };
            axios.get("/applicant/search/jobrequest?page=" + page, request)
                .then(response => {
                    this.page_status = true;
                    this.jobRequestList = response.data;
                    this.jobrequest_count = convertNumberService.convertEng2Mm(this.jobRequestList.total.toString())
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }
    },

    mounted() {
        this.getJobRequest();
    },
    
    computed: {
        ...mapGetters({ applicantId: "applicantId" })
    }
};